import { render } from "./KitchenSummaryPage.vue?vue&type=template&id=1f15eceb&scoped=true"
import script from "./KitchenSummaryPage.vue?vue&type=script&lang=js"
export * from "./KitchenSummaryPage.vue?vue&type=script&lang=js"

import "./KitchenSummaryPage.vue?vue&type=style&index=0&id=1f15eceb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f15eceb"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
